import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import GeneralCountries from './GeneralCountries.js';
import _ from 'lodash';
import { getCountryData } from '../../services/Countries.js';
import MyTabsNested from '../../components/MyTabsNested.js';
import Country from './Country.js';
import { useDispatch } from 'react-redux';
import { setPreview } from '../../redux/actions/previewActions.js';

const EditCountryRecord = () => {

  const { alias } = useParams();
  const [countryTitle, setCountryTitle] = useState();
  const location = useLocation();
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralCountries, subTabs: [
        { id: "basic", title: "Basic", Component: Country }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getCountryData(alias);

          if (result) {
            setCountryTitle(result?.data?.[0]?.name || result?.data?.[0]?.alias);
          }
        }
      } catch (error) {
        console.error('Error fetching Country data:', error);
      }
    };

    getBasicData();
    dispatch(setPreview(false))
  }, [alias, dispatch]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/countries/${alias}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  return (
    <Stack py="5px">
      <Box px="4" pb="4">
        <Text fontSize={"22px"} fontWeight={"600"}>{_.capitalize(countryTitle)}</Text>
      </Box>
      <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/countries"} />
    </Stack>
  );
};

export default EditCountryRecord;